<template>
    <div class="tile is-parent">
        <article class="tile is-child box">
            <p class="title">商品源地址</p>
            <div class="block">
                <input class="input" v-model="params.shopLink"/>
            </div>
            <div v-if="params.shopName" class="block">
                <p class="title">商品源名称</p>
                <span>{{params.shopName}}</span>
            </div>
            <p class="title">关联ICON</p>
            <div class="block">
                <el-select v-model="bloggerIds" multiple filterable placeholder="请选择" style="width: 100%">
                    <el-option
                            v-for="item in bloggers"
                            :key="item.bloggerId"
                            :label="item.name"
                            :value="item.bloggerId">
                    </el-option>
                </el-select>
            </div>
            <div class="block">
                <button class="button" @click="cancelEdit">取消</button>
                <button class="button is-info" @click="saveEdit" style="margin-left: 30px;">保存</button>
            </div>
        </article>
    </div>
</template>
<script type="text/babel">

    export default {
        data(){
            return {
                sourceId: 0,
                params:{
                    shopLink: "",
                    shopName: "",
                },
                bloggers:[],
                bloggerIds:[],
            }
        },
        mounted(){
            this.sourceId = this.$route.query.sourceId;
            if(this.sourceId > 0){
                this.getGoodsSource();
            }
            this.getAllOptions();
        },
        methods:{
            getAllOptions(){
                HttpRequest.get('/admin.php?method=fashion.getBloggers').then(response => {
                    this.bloggers = _.toArray(response.data);
                })
            },
            //获取专题分类详情
            getGoodsSource(){
                HttpRequest.post("/admin.php?method=blogger.getGoodsSource", {sourceId:this.sourceId}).then((response) => {
                    if(response.data){
                        this.params = response.data;
                        this.bloggerIds=[];
                        this.params.bloggers.forEach((item,index)=>{
                            this.bloggerIds.push(item.bloggerId+'')
                        })
                    }
                });
            },
            //保存编辑
            saveEdit(){
                let params ={
                    sourceId:this.sourceId,
                    shopLink:this.params.shopLink,
                    shopName:this.params.shopName,
                    bloggerIds:this.bloggerIds,
                }
                if(!params.shopLink){
                    this.$message("请输入商品源地址");
                    return
                }
                HttpRequest.post("/admin.php?method=blogger.doSaveGoodsSource", params , true).then((response) => {
                    if(response.data.success===1){
                        this.$message("保存成功")
                        this.$router.push({
                            name:"internetStarSource",
                            query:{
                                page:this.$route.query.page?this.$route.query.page:1,
                            }
                        })
                    }
                });
            },
            cancelEdit(){
                this.$router.push({
                    name:"internetStarSource",
                    query:{
                        page:this.$route.query.page,
                    }
                })
            },

        }
    }
</script>
<style lang="less">
</style>
